import LoadJscript from "../components/LoadJscript";
const Home = () => {
     return (
      <main>
        <div className="banner-area banner-area-ptb">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="banner-content">
                            <span data-aos="fade-up" data-aos-delay="900" data-aos-duration="1000" data-aos-once="true">FOR A BETTER FUTURE</span>
                            <h1 data-aos="fade-down" data-aos-delay="900" data-aos-duration="1000" data-aos-once="true">Discover the most exciting online courses</h1>
                            <p data-aos="fade-up" data-aos-delay="900" data-aos-duration="1000" data-aos-once="true">Flexible easy to access learning opportunities can bring a significant change in how individuals prefer to learn! The Ellen can offer you to enjoy the beauty of eLearning!</p>
                            <div className="banner-form-area" data-aos="fade-down" data-aos-delay="900" data-aos-duration="1000" data-aos-once="true">
                                <form className="banner-form" data-toggle="validator" method="POST">
                                    <input type="email" className="form-control" placeholder="Search your courses" name="EMAIL" required autoComplete="off" />
                                    <button className="default-btn" type="submit">
                                        <i className="ri-search-line"></i> Search now
                                    </button>
                                </form>
                            </div>
                            <div className="row">
                                <div className="col-lg-3 col-4 col-sm-3">
                                    <div className="banner-counter" data-aos="fade-up" data-aos-delay="900" data-aos-duration="1000" data-aos-once="true">
                                        <h3>32M</h3>
                                        <p>Learners</p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-4 col-sm-3">
                                    <div className="banner-counter" data-aos="fade-up" data-aos-delay="900" data-aos-duration="1000" data-aos-once="true">
                                        <h3>200M</h3>
                                        <p>Countries</p>
                                    </div>
                                </div>
                                <div className="col-lg-3 col-4 col-sm-3">
                                    <div className="banner-counter" data-aos="fade-up" data-aos-delay="900" data-aos-duration="1000" data-aos-once="true">
                                        <h3>8.1k+</h3>
                                        <p>Courses</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6">
                        <div className="banner-img-two" data-aos="fade-up" data-aos-delay="900" data-aos-duration="1000" data-aos-once="true">
                            <img src="/assets/images/home-two/home-two.png" alt="Man" />
                            <div className="bg-shape">
                                <img src="/assets/images/home-two/home-shape.png" alt="Shape" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <div className="featured-area featured-area-mt pb-70">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-6">
                        <div className="featured-item">
                            <i className="flaticon-studying"></i>
                            <h3>Expedite learning</h3>
                            <p>Duis aute irure dolor in voluptate velit esse cillum labore .</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-6">
                        <div className="featured-item">
                            <i className="flaticon-platform"></i>
                            <h3>Open-source platform</h3>
                            <p>Duis aute irure dolor in voluptate velit esse cillum labore .</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-6">
                        <div className="featured-item">
                            <i className="flaticon-effective"></i>
                            <h3>Maximum efficiency</h3>
                            <p>Duis aute irure dolor in voluptate velit esse cillum labore .</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
        <div className="categories-area pb-70">
            <div className="container">
                <div className="section-title mb-45">
                    <h2>Explore top featured <b>categories</b></h2>
                </div>
                <div className="categories-slider owl-carousel owl-theme">
                    <div className="categories-item">
                        <a href="courses-details.html">
                            <img src="/assets/images/categories/categories-img1.jpg" alt="Categories" />
                        </a>
                        <div className="content">
                            <a href="courses-details.html">
                                <i className="flaticon-web-development"></i>
                                <h3>Development</h3>
                            </a>
                        </div>
                    </div>
                    <div className="categories-item">
                        <a href="courses-details.html">
                            <img src="/assets/images/categories/categories-img2.jpg" alt="Categories" />
                        </a>
                        <div className="content">
                            <a href="courses.html">
                                <i className="flaticon-design"></i>
                                <h3>Web designing</h3>
                            </a>
                        </div>
                    </div>
                    <div className="categories-item">
                        <a href="courses-details.html">
                            <img src="/assets/images/categories/categories-img3.jpg" alt="Categories" />
                        </a>
                        <div className="content">
                            <a href="courses.html">
                                <i className="flaticon-wellness"></i>
                                <h3>Art & design</h3>
                            </a>
                        </div>
                    </div>
                    <div className="categories-item">
                        <a href="courses-details.html">
                            <img src="/assets/images/categories/categories-img4.jpg" alt="Categories" />
                        </a>
                        <div className="content">
                            <a href="courses.html">
                                <i className="flaticon-heart-beat"></i>
                                <h3>Health & fitness</h3>
                            </a>
                        </div>
                    </div>
                    <div className="categories-item">
                        <a href="courses-details.html">
                            <img src="/assets/images/categories/categories-img5.jpg" alt="Categories" />
                        </a>
                        <div className="content">
                            <a href="courses.html">
                                <i className="flaticon-camera"></i>
                                <h3>Photography</h3>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <div className="enrolled-area pt-100 pb-70">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="enrolled-img-two mb-30" data-speed="0.05" data-revert="true">
                            <img src="/assets/images/enrolled/enrolled-img2.png" alt="Enrolled" />
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="enrolled-content mb-30">
                            <div className="section-title">
                                <h2>We have the most qualified instructors in your hometown.</h2>
                                <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.
                                </p>
                            </div>
                            <div className="row">
                                <div className="col-lg-6 col-6">
                                    <ul className="enrolled-list">
                                        <li><i className="flaticon-check"></i> Full lifetime access</li>
                                        <li><i className="flaticon-check"></i> Certificate of completion</li>
                                    </ul>
                                </div>

                                <div className="col-lg-6 col-6">
                                    <ul className="enrolled-list">
                                        <li><i className="flaticon-check"></i> 20+ downloadable resources</li>
                                        <li><i className="flaticon-check"></i> Free trial 7 days</li>
                                    </ul>
                                </div>
                            </div>
                            <a href="courses.html" className="default-btn">Enrolled today</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <div className="counter-area-two section-bg pb-70">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-6">
                        <div className="counter-card">
                            <i className="flaticon-online-course"></i>
                            <h3><span className="odometer" data-count="15000">00000</span>+</h3>
                            <p>Courses & videos</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-6">
                        <div className="counter-card">
                            <i className="flaticon-student"></i>
                            <h3><span className="odometer" data-count="145000">000000</span>+</h3>
                            <p>Students enrolled</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-6">
                        <div className="counter-card">
                            <i className="flaticon-online-course-1"></i>
                            <h3><span className="odometer" data-count="10000">00000</span>+</h3>
                            <p>Courses instructors</p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-6">
                        <div className="counter-card">
                            <i className="flaticon-customer-satisfaction"></i>
                            <h3><span className="odometer" data-count="100">000</span>%</h3>
                            <p>Satisfaction rate</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <div className="courses-area courses-area-rs pt-100 pb-70">
            <div className="container">
                <div className="section-title mb-45">
                    <h2>Find popular <b>courses</b></h2>
                </div>
                <div className="course-slider owl-carousel owl-theme">
                    <div className="courses-item">
                        <a href="courses-details.html">
                            <img src="/assets/images/courses/courses-img7.jpg" alt="Courses" />
                        </a>
                        <div className="content">
                            <div className="course-instructors">
                                <img src="/assets/images/courses/instructors1.jpg" alt="instructors" />
                            </div>
                            <a href="courses.html" className="tag-btn">Finance</a>
                            <h3><a href="courses-details.html">The complete business plan course includes 50 templates</a></h3>
                            <ul className="course-list">
                                <li><i className="ri-time-fill"></i> 10 hr 07 min</li>
                                <li><i className="ri-vidicon-fill"></i> 67 lectures</li>
                            </ul>
                            <div className="bottom-content">
                                <div className="rating2">
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    5 (30+ rating)
                                </div>
                                <div className="bottom-price">$120</div>
                            </div>
                        </div>
                    </div>
                    <div className="courses-item">
                        <a href="courses-details.html">
                            <img src="/assets/images/courses/courses-img8.jpg" alt="Courses" />
                        </a>
                        <div className="content">
                            <div className="course-instructors">
                                <img src="/assets/images/courses/instructors2.jpg" alt="instructors" />
                            </div>
                            <a href="courses.html" className="tag-btn">Banking</a>
                            <h3><a href="courses-details.html">Full web designing course with 20 web template designing</a></h3>
                            <ul className="course-list">
                                <li><i className="ri-time-fill"></i> 03 hr 10 min</li>
                                <li><i className="ri-vidicon-fill"></i> 27 lectures</li>
                            </ul>
                            <div className="bottom-content">
                                <div className="rating2">
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    5 (50+ rating)
                                </div>
                                <div className="bottom-price">$400</div>
                            </div>
                        </div>
                    </div>
                    <div className="courses-item">
                        <a href="courses-details.html">
                            <img src="/assets/images/courses/courses-img9.jpg" alt="Courses" />
                        </a>
                        <div className="content">
                            <div className="course-instructors">
                                <img src="/assets/images/courses/instructors3.jpg" alt="instructors" />
                            </div>
                            <a href="courses.html" className="tag-btn">Physics</a>
                            <h3><a href="courses-details.html">Visual effects for games in unity beginner to intermediate</a></h3>
                            <ul className="course-list">
                                <li><i className="ri-time-fill"></i> 02 hr 00 min</li>
                                <li><i className="ri-vidicon-fill"></i> 17 lectures</li>
                            </ul>
                            <div className="bottom-content">
                                <div className="rating2">
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    5 (10+ rating)
                                </div>
                                <div className="bottom-price">$100</div>
                            </div>
                        </div>
                    </div>
                    <div className="courses-item">
                        <a href="courses-details.html">
                            <img src="/assets/images/courses/courses-img2.jpg" alt="Courses" />
                        </a>
                        <div className="content">
                            <div className="course-instructors">
                                <img src="/assets/images/courses/instructors4.jpg" alt="instructors" />
                            </div>
                            <a href="courses.html" className="tag-btn">Accounting</a>
                            <h3><a href="courses-details.html">Basic knowledge about hibernal bharat in history</a></h3>
                            <ul className="course-list">
                                <li><i className="ri-time-fill"></i> 03 hr 30 min</li>
                                <li><i className="ri-vidicon-fill"></i> 37 lectures</li>
                            </ul>
                            <div className="bottom-content">
                                <div className="rating2">
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    <i className="ri-star-fill"></i>
                                    5 (30+ rating)
                                </div>
                                <div className="bottom-price">$160</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      
        <div className="testimonials-area section-bg ptb-100">
            <div className="container">
                <div className="section-title mb-45 text-center">
                    <h2>What people say <b>about us</b></h2>
                </div>
                <div className="testimonials-slider owl-carousel owl-theme">
                    <div className="testimonials-card">
                        <div className="content">
                            <img src="/assets/images/testimonials/testimonials-img1.jpg" alt="testimonials" />
                            <h3>Nikolas albart</h3>
                            <span>Student</span>
                        </div>
                        <div className="quote"> <i className="flaticon-quote"></i></div>
                        <p>“Morbi porttitor ligula id varius consectetur. Integer ipsum justo, congue sit amet massa vel, porttitor semper magna. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus.”</p>
                        <div className="rating">
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                        </div>
                    </div>
                    <div className="testimonials-card">
                        <div className="content">
                            <img src="/assets/images/testimonials/testimonials-img2.jpg" alt="testimonials" />
                            <h3>Terry ambady</h3>
                            <span>Content strategist</span>
                        </div>
                        <div className="quote"> <i className="flaticon-quote"></i></div>
                        <p>“Morbi porttitor ligula id varius consectetur. Integer ipsum justo, congue sit amet massa vel, porttitor semper magna. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus.”</p>
                        <div className="rating">
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                        </div>
                    </div>
                    <div className="testimonials-card">
                        <div className="content">
                            <img src="/assets/images/testimonials/testimonials-img3.jpg" alt="testimonials" />
                            <h3>Cory zamora</h3>
                            <span>Photographer</span>
                        </div>
                        <div className="quote"> <i className="flaticon-quote"></i></div>
                        <p>“Morbi porttitor ligula id varius consectetur. Integer ipsum justo, congue sit amet massa vel, porttitor semper magna. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus.”</p>
                        <div className="rating">
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                        </div>
                    </div>
                    <div className="testimonials-card">
                        <div className="content">
                            <img src="/assets/images/testimonials/testimonials-img3.jpg" alt="testimonials" />
                            <h3>Jonquil von</h3>
                            <span>Photographer</span>
                        </div>
                        <div className="quote"> <i className="flaticon-quote"></i></div>
                        <p>“Morbi porttitor ligula id varius consectetur. Integer ipsum justo, congue sit amet massa vel, porttitor semper magna. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus.”</p>
                        <div className="rating">
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                            <i className="ri-star-fill"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <div className="instructors-area instructors-area-rs pt-100 pb-70">
            <div className="container">
                <div className="section-title mb-45">
                    <h2>Meet our top <b>instructor</b> </h2>
                </div>

                <div className="instructors-slider owl-carousel owl-theme">
                    <div className="instructors-card">
                        <a href="instructors-details.html">
                            <img src="/assets/images/instructors/instructors-img1.jpg" alt="Team Images" />
                        </a>
                        <div className="content">
                            <ul className="instructors-social">
                                <li className="share-btn"><i className="ri-add-line"></i></li>
                                <li>
                                    <a href="https://www.facebook.com/" target="_blank">
                                        <i className="ri-facebook-fill"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/" target="_blank">
                                        <i className="ri-instagram-line"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/" target="_blank">
                                        <i className="ri-twitter-fill"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/" target="_blank">
                                        <i className="ri-linkedin-box-line"></i>
                                    </a>
                                </li>
                            </ul>
                            <h3><a href="instructors-details.html">Sally welch</a></h3>
                            <span>Web designer</span>
                        </div>
                    </div>
                    <div className="instructors-card">
                        <a href="instructors-details.html">
                            <img src="/assets/images/instructors/instructors-img2.jpg" alt="Team Images"/>
                        </a>
                        <div className="content">
                            <ul className="instructors-social">
                                <li className="share-btn"><i className="ri-add-line"></i></li>
                                <li>
                                    <a href="https://www.facebook.com/" target="_blank">
                                        <i className="ri-facebook-fill"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/" target="_blank">
                                        <i className="ri-instagram-line"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/" target="_blank">
                                        <i className="ri-twitter-fill"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/" target="_blank">
                                        <i className="ri-linkedin-box-line"></i>
                                    </a>
                                </li>
                            </ul>
                            <h3><a href="instructors-details.html">Jesse joslin</a></h3>
                            <span>Content strategist</span>
                        </div>
                    </div>
                    <div className="instructors-card">
                        <a href="instructors-details.html">
                            <img src="/assets/images/instructors/instructors-img3.jpg" alt="Team Images" />
                        </a>
                        <div className="content">
                            <ul className="instructors-social">
                                <li className="share-btn"><i className="ri-add-line"></i></li>
                                <li>
                                    <a href="https://www.facebook.com/" target="_blank">
                                        <i className="ri-facebook-fill"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/" target="_blank">
                                        <i className="ri-instagram-line"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/" target="_blank">
                                        <i className="ri-twitter-fill"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/" target="_blank">
                                        <i className="ri-linkedin-box-line"></i>
                                    </a>
                                </li>
                            </ul>
                            <h3><a href="instructors-details.html">Lance altman</a></h3>
                            <span>Photographer</span>
                        </div>
                    </div>
                    <div className="instructors-card">
                        <a href="instructors-details.html">
                            <img src="/assets/images/instructors/instructors-img4.jpg" alt="Team Images"/>
                        </a>
                        <div className="content">
                            <ul className="instructors-social">
                                <li className="share-btn"><i className="ri-add-line"></i></li>
                                <li>
                                    <a href="https://www.facebook.com/" target="_blank">
                                        <i className="ri-facebook-fill"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/" target="_blank">
                                        <i className="ri-instagram-line"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/" target="_blank">
                                        <i className="ri-twitter-fill"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/" target="_blank">
                                        <i className="ri-linkedin-box-line"></i>
                                    </a>
                                </li>
                            </ul>
                            <h3><a href="instructors-details.html">Jonquil von</a></h3>
                            <span>Art director</span>
                        </div>
                    </div>
                    <div className="instructors-card">
                        <a href="instructors-details.html">
                            <img src="/assets/images/instructors/instructors-img5.jpg" alt="Team Images"/>
                        </a>
                        <div className="content">
                            <ul className="instructors-social">
                                <li className="share-btn"><i className="ri-add-line"></i></li>
                                <li>
                                    <a href="https://www.facebook.com/" target="_blank">
                                        <i className="ri-facebook-fill"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.instagram.com/" target="_blank">
                                        <i className="ri-instagram-line"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://twitter.com/" target="_blank">
                                        <i className="ri-twitter-fill"></i>
                                    </a>
                                </li>
                                <li>
                                    <a href="https://www.linkedin.com/" target="_blank">
                                        <i className="ri-linkedin-box-line"></i>
                                    </a>
                                </li>
                            </ul>
                            <h3><a href="instructors-details.html">Oliva welch</a></h3>
                            <span>Web designer</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
       
        <div className="brand-area">
            <div className="container">
                <div className="brand-slider owl-carousel owl-theme pb-100">
                     <div className="brand-item">
                        <img src="/assets/images/brand-logo/1.png" className="brand-item-logo1" alt="Images"/>
                        <img src="/assets/images/brand-logo/brand-logo1.png" className="brand-item-logo2" alt="Images"/>
                    </div>

                    <div className="brand-item">
                        <img src="/assets/images/brand-logo/2.png" className="brand-item-logo1" alt="Images"/>
                        <img src="/assets/images/brand-logo/brand-logo2.png" className="brand-item-logo2" alt="Images"/>
                    </div>

                    <div className="brand-item">
                        <img src="/assets/images/brand-logo/3.png" className="brand-item-logo1" alt="Images"/>
                        <img src="/assets/images/brand-logo/brand-logo3.png" className="brand-item-logo2" alt="Images"/>
                    </div>

                    <div className="brand-item">
                        <img src="/assets/images/brand-logo/4.png" className="brand-item-logo1" alt="Images"/>
                        <img src="/assets/images/brand-logo/brand-logo4.png" className="brand-item-logo2" alt="Images"/>
                    </div>

                    <div className="brand-item">
                        <img src="/assets/images/brand-logo/5.png" className="brand-item-logo1" alt="Images"/>
                        <img src="/assets/images/brand-logo/brand-logo5.png" className="brand-item-logo2" alt="Images"/>
                    </div>

                    <div className="brand-item">
                        <img src="/assets/images/brand-logo/6.png" className="brand-item-logo1" alt="Images"/>
                        <img src="/assets/images/brand-logo/brand-logo6.png" className="brand-item-logo2" alt="Images"/>
                    </div>
                </div>
            </div>
        </div>
      
        <div className="blog-area section-bg pt-100 pb-70">
            <div className="container">
                <div className="section-title text-center mb-45">
                    <h2>Latest from our <b>blogs</b></h2>
                </div>
                <div className="row justify-content-center">
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-card">
                            <a href="single-blog-1.html">
                                <img src="/assets/images/blog/blog-img4.jpg" alt="Blog"/>
                            </a>
                            <div className="content">
                                <ul>
                                    <li><i className="ri-calendar-todo-fill"></i> Jan 12,2024  </li>
                                    <li><i className="ri-price-tag-3-fill"></i> <a href="tags.html">Education</a></li>
                                </ul>
                                <h3><a href="single-blog-1.html">All that is wrong with codding in the field of apprentices</a></h3>
                                <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                                <a href="single-blog-1.html" className="read-btn">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-card">
                            <a href="single-blog-1.html">
                                <img src="/assets/images/blog/blog-img2.jpg" alt="Blog"/>
                            </a>
                            <div className="content">
                                <ul>
                                    <li><i className="ri-calendar-todo-fill"></i> Jan 13,2024  </li>
                                    <li><i className="ri-price-tag-3-fill"></i> <a href="tags.html">learning</a></li>
                                </ul>
                                <h3><a href="single-blog-1.html">How to use technology to adapt your talent to the world</a></h3>
                                <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                                <a href="single-blog-1.html" className="read-btn">Read More</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="blog-card">
                            <a href="single-blog-1.html">
                                <img src="/assets/images/blog/blog-img5.jpg" alt="Blog"/>
                            </a>
                            <div className="content">
                                <ul>
                                    <li><i className="ri-calendar-todo-fill"></i> Jan 15,2024  </li>
                                    <li><i className="ri-price-tag-3-fill"></i> <a href="tags.html">Courses</a></li>
                                </ul>
                                <h3><a href="single-blog-1.html">Here are the things to look for when selecting an online course</a></h3>
                                <p>Lorem ipsum dolor sit amet, constetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                                <a href="single-blog-1.html" className="read-btn">Read More</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <LoadJscript/>
      </main>
    );
  }
  
  export default Home;  